import React from "react";
import './index.css'
import ReactDOM from 'react-dom/client'
import App from './App'

const myRoot = ReactDOM.createRoot(document.getElementById('root'));
myRoot.render(<App/>);